// Карточка объекта МКД. КАРКАС: backend готов.
// Заполнить по образцу ContractDetailPage: конструктивы, договоры, документы.
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { objectsApi } from '@/api';
import { AppLayout } from '@/components/layout/AppLayout';
import { Spinner } from '@/components/ui/Spinner';
import { formatNumber } from '@/lib/format';

export function ObjectDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: obj, isLoading } = useQuery({ queryKey: ['object', Number(id)], queryFn: () => objectsApi.get(Number(id)) });
  if (isLoading) return <AppLayout><Spinner /></AppLayout>;
  if (!obj) return <AppLayout><div>Объект не найден</div></AppLayout>;
  return (
    <AppLayout>
      <button className="back-btn" onClick={() => navigate('/objects')}><ArrowLeft size={16} /> К объектам</button>
      <div className="contract-head"><div className="contract-head__number" style={{ fontSize: 26 }}>{obj.address}</div></div>
      <div className="card" style={{ maxWidth: 600 }}>
        <h3 className="card-title">Характеристики</h3>
        <dl className="detail-list">
          <div className="detail-row"><dt>Год постройки</dt><dd className="mono">{obj.year_built || '—'}</dd></div>
          <div className="detail-row"><dt>Этажность</dt><dd className="mono">{obj.floors || '—'}</dd></div>
          <div className="detail-row"><dt>Подъездов</dt><dd className="mono">{obj.entrances || '—'}</dd></div>
          <div className="detail-row"><dt>Квартир</dt><dd className="mono">{obj.apartments || '—'}</dd></div>
          <div className="detail-row"><dt>Площадь</dt><dd className="mono">{formatNumber(obj.total_area)} м²</dd></div>
        </dl>
      </div>
    </AppLayout>
  );
}
